module.exports = {
  placeholderInput: '请输入',
  placeholderSelect: '请选择',
  productCode: '产品代号',
  productName: '产品名称',
  productSize: '产品尺码',
  sendStatus: '发送状态',
  taggingTime: '绑定时间',
  search: '搜索',
  clear: '清空',
  status: '状态',
  total: '总计',
  success: '操作成功',
  errorTitle: '错误',
  infoTitle: '通知',
  successTitle: '成功',
  warningTitle: '警告',
  confirmTitle: '确认',
  tagSuccess: '绑定成功',
  products: '产品',
  resendFailed: '重新发送失败',
  sendTime: '发送时间',
  workStation: '操作台',
  operator: '操作者',
  sendFail: '发送失败行',
  sendSuccess: '发送成功行',
  sendTotal: '发送总行数',
  resend: '重发',
  isRequired: '是必填。',
  delete: '删除 ',
  addNew: '新增',
  edit: '编辑',
  all: '全选',
  last7: '最近7天',
  last30: '最近30天',
  last90: '最近90天',
  download: '下载',
  downloadError: '获取文件失败',
  error404: '您访问的页面不存在。',
  errorAuth: '很抱歉！',
  placeholderFormat: '格式：\nXXXXXX\nXXXXXX'
}
